import * as React from "react";
import "./PageHeader.scss";

export default function PageHeader() {
    return (
        <div className="PageHeader">
            <img src="http://zyai.ac.cn/images/logo.png" alt="logo" className="header-logo"/>
            <div className="header-title-container">
                <span className="header-title">上海市致远人工智能研究院</span>
                <span className="header-subtitle">Shanghai Zhiyuan Academy of Artificial Intelligence</span>
            </div>
        </div>
    )
}
